import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service2 from "../../assets/images/service/02.jpg";

import ImgLap from "../../assets/images/service_detail/laparoscopic/01.jpg";
import ImgLap2 from "../../assets/images/service_detail/laparoscopic/02.jpg";
import ImgLapInstrument from "../../assets/images/service_detail/laparoscopic/03.jpg";

const LaparoscopicData = () => {

const data = {
title:"Laparoscopic Urology Surgery",
subtitle:"Minimally invasive urology surgery",

heading:"Advanced Laparoscopic Treatment",
description:"Laparoscopic surgery is performed using small incisions and camera-based instruments to treat urological conditions with faster recovery.",

image:Service2,

sections:[

{
title:"What is Laparoscopic Urology Surgery?",
content:"Laparoscopic urology surgery is an advanced minimally invasive surgical technique used to treat various urological conditions using small incisions and a high-definition camera. A thin instrument called laparoscope is inserted through tiny cuts to view internal organs and perform surgery with precision. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia performs advanced laparoscopic urology surgeries using modern equipment ensuring safe treatment, minimal pain and faster recovery for patients.",
image: ImgLap
},

{
title:"Advantages of Laparoscopic Surgery",
content:"Laparoscopic urology surgery is an advanced minimally invasive technique that allows treatment through very small incisions using a camera and specialized instruments. Compared to traditional open surgery, laparoscopic procedures provide faster recovery, less pain and better cosmetic results for patients.",
list:[
"Small incisions (5–10 mm) with minimal visible scars",
"Less post-operative pain and faster healing",
"Short hospital stay and early discharge",
"Minimal blood loss during surgery",
"Lower risk of infection and complications",
"Faster return to daily routine and work",
"Better cosmetic and aesthetic outcomes"
]
},

{
title:"Conditions Treated with Laparoscopic Urology Surgery",
content:"Laparoscopic surgery is widely used to treat various kidney, bladder and prostate conditions safely and effectively. It allows precise treatment with minimal tissue damage and faster recovery.",
list:[
"Kidney stones requiring surgical removal",
"Kidney tumors and masses",
"Prostate enlargement and related problems",
"Kidney cysts and structural abnormalities",
"Ureter obstruction or blockage",
"Bladder disorders and tumors",
"Urological cancers requiring surgical treatment"
],
image: ImgLap2
},

{
title:"How is Laparoscopic Surgery Performed?",
content:"Laparoscopic surgery is performed under anesthesia using small keyhole incisions in the abdomen. A thin camera (laparoscope) is inserted to provide a clear magnified view of internal organs on a monitor. Specialized surgical instruments are then used to remove stones, tumors or correct the problem with high precision. The minimally invasive approach ensures less pain, minimal bleeding and quicker recovery compared to open surgery.",
image: ImgLapInstrument
},

{
title:"Preparation Before Laparoscopic Surgery",
content:"Proper preparation before laparoscopic surgery helps ensure safety and successful outcomes. Patients are advised to follow doctor’s instructions carefully before the procedure.",
list:[
"Avoid eating or drinking for 6–8 hours before surgery",
"Inform doctor about ongoing medicines or medical conditions",
"Complete required blood tests and imaging scans",
"Wear comfortable clothing on surgery day",
"Follow all pre-surgery medical instructions carefully"
]
},

{
title:"Recovery After Laparoscopic Surgery",
content:"Recovery after laparoscopic surgery is usually quick due to small incisions and minimal tissue damage. Most patients can start walking within 24 hours and are discharged within 1–2 days. Complete recovery generally takes 1–2 weeks depending on the procedure. Patients are advised to avoid heavy lifting and follow medical advice for smooth healing.",
},

{
title:"Possible Risks or Side Effects",
content:"Laparoscopic surgery is considered very safe and effective. However, like any surgical procedure, minor temporary side effects may occur in some patients.",
list:[
"Mild pain or swelling at incision site",
"Temporary discomfort after surgery",
"Minor bleeding or bruising",
"Rare risk of infection",
"Reaction to anesthesia in rare cases"
]
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Laparoscopic Surgery?",
content:"Dr. Sachitanand Chaurasia is a highly experienced urologist known for advanced laparoscopic urology surgeries. At BBMH (Brijesh Banger Memorial Hospital), patients receive world-class treatment using modern operation theatre and advanced technology. The focus is always on safe surgery, minimal pain and faster recovery ensuring best outcomes for every patient."
}

],

faq:[
{q:"Is laparoscopic surgery safe?",a:"Yes, very safe."},
{q:"Hospital stay?",a:"1-2 days only."},
{q:"Recovery?",a:"Very fast recovery."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default LaparoscopicData;
